import React from "react";

const DarkModeFill = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          className="u_fill"
          d="M17.023 2a12.014 12.014 0 00-.305 17.281A12.01 12.01 0 0034 18.976C33.49 27.36 26.53 34 18.018 34 9.17 34 2 26.83 2 17.985 2 9.473 8.64 2.512 17.023 2z"
          fill={fill}
      />
    </svg>
);

export default DarkModeFill;
